<template>
  <div>
    <!-- <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->

    <v-dialog v-model="loading_download" persistent width="300">
      <v-card color="#4EBCA6" dark class="pt-1">
        <v-card-text class="text-center">
          <div class="pt-2 white--text font-16">
            กำลังดาวน์โหลดเอกสาร
          </div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container fluid :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'" style="min-height: 100vh">
      <!-- <div v-show="almost_mobile" style="margin-top: 15%"></div> -->
      <h3 class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        ใบรับรองแพทย์
      </h3>
      <div style="margin-top: 30px"></div>
      <v-row class="mx-1 my-2 mt-8">
        <v-spacer></v-spacer>
        <v-col cols="auto" class="pr-0">
          <v-btn color="#00a99d" dark @click="openRequestDialog()" class="card-small">
            <v-icon color="#FFFFFF">mdi-plus-circle</v-icon>
            <span class="pl-2">ขอเอกสาร</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row align="center" class="pt-3 mx-1">
        <v-col cols="12" sm="4" md="4" lg="4" class="pt-0 pr-0" v-for="(item, index) in statusList" :key="index">
          <v-card class="d-flex align-center card-medium" height="70" @click="filterStatus(index)"
            :color="filter_status == index ? 'bg-00A99D' : 'bg-CEEFED'">
            <v-row>
              <v-col cols="auto" class="pb-1" align-self="center">
                <img :src="filter_status == index
                  ? require('../../assets/icon/medcert/' + item.imgActive)
                  : require('../../assets/icon/medcert/' + item.img)
                  " class="ml-3 pa-3" :class="filter_status == index ? 'icon-dark' : 'icon-light'" alt="all" />
              </v-col>
              <v-col cols="6" lg="8" md="7" sm="5" class="px-0" align-self="center">
                <v-row>
                  <v-col cols="12" class="py-0" align="center">
                    <span class="font-18 font-weight-bold" :style="`color: ${filter_status == index ? '#FFFFFF' : '#00a99d'
                      };`">
                      {{ item.number }}
                    </span>
                  </v-col>
                  <v-col cols="12" class="py-0" align="center">
                    <span class="font-18" :style="`color: ${filter_status == index ? '#FFFFFF' : '#00a99d'
                      };`">
                      {{ item.title }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- <div class="bg-while"> -->
      <v-row class="pl-2 py-0 mx-1 mt-6">
        <v-col cols="12" lg="3" md="3" sm="12" class="card-search pa-2">
          <v-text-field v-model="filter_name" class="card-small" label="ค้นหาชื่อ" dense solo hide-details="auto"
            append-icon="mdi-magnify" clearable clear-icon="mdi-close-circle" @click:clear="filter_name = ''"
            color="#00A99D"></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" lg="2" md="2" sm="12" class="bg-ceefed card-search-start pa-2">
          <v-autocomplete solo dense v-model="filter_doc_type" :items="document_list" item-text="doc_name"
            class="card-small" return-object placeholder="" hide-details color="#00A99D" item-color="teal darken-2"
            @input="select_dcot_type()">
            <!-- <template v-slot:prepend-inner>
              <img src="../../assets/icon/medcert/doctor.svg" alt="doctor" />
            </template> -->
            <template v-slot:append>
              <img style="cursor: pointer" src="../../assets/icon/medcert/down.svg" alt="down" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" lg="2" md="2" sm="12" class="bg-ceefed pa-2" v-if="role_name !== 'แพทย์'">
          <v-autocomplete solo dense v-model="filter_doctor" :items="doctorList" item-text="name_th" class="card-small"
            return-object placeholder="" @input="searchDoctor()" hide-details color="#00A99D"
            item-color="teal darken-2">
            <template v-slot:prepend-inner>
              <img src="../../assets/icon/medcert/doctor.svg" alt="doctor" />
            </template>
            <template v-slot:append>
              <img style="cursor: pointer" src="../../assets/icon/medcert/down.svg" alt="down" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" lg="2" md="2" sm="12" class="bg-ceefed pa-2">
          <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="auto" :return-value.sync="filter_date">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date_format" solo readonly dense hide-details persistent-hint v-bind="attrs"
                v-on="on" color="#00A99D" class="card-small">
                <template v-slot:append>
                  <img style="cursor: pointer" src="../../assets/icon/medcert/calendar.svg" alt="calendar" />
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="filter_date" no-title locale="th-th" :first-day-of-week="1" :max="today"
              color="#00A99D">
              <v-spacer></v-spacer>
              <v-btn text color="#00A99D" @click="menu = false"> Cancel </v-btn>
              <v-btn text color="#00A99D" @click="$refs.menu.save(saveDate(filter_date))">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="auto" class="card-search-end pa-2">
          <v-btn color="#00a99d" dark @click="clearFilter()" class="card-small">
            <span class="font-14">ล้างค่า</span>
          </v-btn>
        </v-col>
      </v-row>
      <!-- </div> -->

      <v-row align="center" class="py-5 my-0 mx-1">
        <v-col cols="12" align="center" class="pr-0">
          <v-data-table :headers="headers" :items="dataList" :items-per-page="10" hide-default-footer
            :loading="loadingTable" loading-text="กำลังโหลดข้อมูล" no-data-text="ไม่มีข้อมูล">
            <template v-slot:no-data>
              <span class="font-16">ไม่มีข้อมูล</span>
            </template>

            <template v-slot:progress>
              <v-progress-linear indeterminate height="3px" color="#00A99D" class="mx-0"></v-progress-linear>
            </template>

            <template v-slot:[`item.date_th`]="{ item }">
              <div class="d-flex flex-column" v-if="item.date_th !== 'Invalid date'">
                <span>{{ item.date_th }}</span>
                <!-- <span style="color: #336AB4; font-size: 12px !important;">{{ item.date_th_mmmm }}</span> -->
              </div>
              <div class="d-flex flex-column" v-else>
                <span> - </span>
              </div>
            </template>

            <template v-slot:[`item.create_at_th`]="{ item }">
              <div class="d-flex flex-column">
                <span>{{ item.create_at_th }}</span>
                <!-- <span style="color: #336AB4; font-size: 12px !important;">{{ item.create_at_th_mmmm }}</span> -->
              </div>
            </template>

            <!-- <template v-slot:[`item.update_at_th`]="{ item }">
              <div class="d-flex flex-column">
                <span>{{ item.update_at_th }}</span>
                <span style="color: #336AB4; font-size: 12px !important;">{{ item.update_at_th_mmmm }}</span>
              </div>
            </template> -->

            <template v-slot:[`item.doctor_name`]="{ item }">
              <div class="d-flex flex-column">
                <span>{{ item.doctor_name }}</span>
                <span style="color: #5f676b; font-size: 12px !important">{{
                  item.doctor_license
                }}</span>
              </div>
            </template>

            <template v-slot:[`item.status_th`]="{ item }">
              <div class="d-flex justify-center">
                <span :style="item.status_th === 'สำเร็จ'
                  ? 'color: #2CC8A7'
                  : item.status_th === 'ยกเลิก'
                    ? 'color: #FF8082'
                    : item.status_th === 'กำลังดำเนินการ'
                      ? 'color: #3576CB'
                      : 'color: #FFC259'
                  ">●&nbsp;</span>
                <span>{{ item.status_th }}</span>
              </div>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-tooltip bottom color="#00a99d">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" color="#3576CB" :disabled="item.status === 'success' ||
                    item.status === 'cancel' ||
                    lockaprove ||
                    item.approve_sign
                    " @click="approveDialog(item, item.item.patient.patient_age)" icon>
                    <!-- <v-icon>mdi-file-document-edit</v-icon> -->
                    <v-img max-height="20" max-width="20" v-if="
                      item.status === 'success' ||
                      item.status === 'cancel' ||
                      lockaprove ||
                      item.approve_sign
                    " src="@/assets/img/edt dis.svg"></v-img>
                    <v-img max-height="20" max-width="20" v-else src="@/assets/img/edt di.svg"></v-img>
                  </v-btn>
                </template>
                <span>อนุมัติ</span>
              </v-tooltip>
              <v-tooltip bottom color="#00a99d">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="#3576CB" :disabled="item.status !== 'success'" @click="dowloadDialog(item)" icon
                    v-bind="attrs" v-on="on">
                    <!-- <v-icon>mdi-download</v-icon> -->
                    <v-img max-height="20" max-width="20" v-if="item.status !== 'success'"
                      src="@/assets/img/download dis.svg"></v-img>
                    <v-img max-height="20" max-width="20" v-else src="@/assets/img/download dis-1.svg"></v-img>
                  </v-btn>
                </template>
                <span>ดาวน์โหลด</span>
              </v-tooltip>
              <!-- <v-tooltip bottom color="#00a99d">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="#3576CB"
                    :disabled="item.status !== 'request'"
                    @click="cancleDialog(item._id)"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-img max-height="20" max-width="20" v-if="item.status !== 'request'" src="@/assets/img/trash-2 dis.svg"></v-img>
                    <v-img max-height="20" max-width="20" v-else src="@/assets/img/trash-2 dis-1.svg"></v-img>
                  </v-btn>
                </template>
                <span>ยกเลิก</span>
              </v-tooltip> -->
            </template>
          </v-data-table>
          <Pagination :totals="total" :isPage="page" @page="changePage" />

          <RequestDocDialog ref="requestDocDialog" />
          <MedcertDialog ref="medcertDialog" />
          <DrivingLicense ref="dialog_driving" />
          <formForeingWorkers ref="dialog_foreingworkers" />
          <CancelDialog ref="cancelDialog" />
          <ControlledHerbs ref="dialog_controlled_herbs" />
          <PrescriptionCert ref="dialog_prescription_cert" />
          <CommentCert ref="dialog_comment_cert" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Pagination } from "@/components/pagination/";

//dialog
import RequestDocDialog from "@/components/dialog/RequestDocDialog.vue";
import MedcertDialog from "@/components/dialog/MedcertDialog.vue";
import CancelDialog from "@/components/dialog/CancelDocDialog.vue";
import formForeingWorkers from "@/components/dialog/MedcertForeingWorkersDialog.vue";
import ControlledHerbs from "@/components/dialog/ControlledHerbsDialog.vue";
import DrivingLicense from "@/components/dialog/DrivingLicenseDialog.vue";
import PrescriptionCert from "@/components/dialog/PrescriptionCertDialog.vue";
import CommentCert from "@/components/dialog/CommentCertDialog.vue";
import { EventBus } from "@/EventBus";

import moment from "moment";

export default {
  components: {
    Pagination,
    RequestDocDialog,
    MedcertDialog,
    CancelDialog,
    DrivingLicense,
    formForeingWorkers,
    ControlledHerbs,
    PrescriptionCert,
    CommentCert
  },
  data() {
    return {
      filter_name: "",
      filter_doc_type: {
        doc_name: "ทั้งหมด",
        doc_code: "",
      },
      document_list: [
        {
          doc_name: "ทั้งหมด",
          doc_code: "",
        },
      ],
      filter_doctor: {
        one_id: "all",
        name_th: "แพทย์ทั้งหมด",
      },
      filter_date: "",
      today: moment().format("YYYY-MM-DD"),
      filter_status: "",
      menu: false,
      statusList: [
        {
          title: "ทั้งหมด",
          number: 0,
          img: "all-light.svg",
          imgActive: "all-dark.svg",
        },
        {
          title: "เอกสารที่ร้องขอ",
          number: 0,
          img: "transport.svg",
          imgActive: "transport.svg",
        },
        {
          title: "สำเร็จ",
          number: 0,
          img: "success.svg",
          imgActive: "success.svg",
        },
        // {title: "ยกเลิก", number: 0, img: "cancle.svg"},
      ],
      doctorList: [],
      patientList: [],
      headers: [
        {
          text: "ประเภทเอกสาร",
          value: "doc_name",
          width: "15%",
          sortable: false,
          align: "center",
          class: "text-313B41 w-400",
        },
        {
          text: "ชื่อผู้ป่วย",
          value: "item.patient.patient_name",
          width: "17%",
          sortable: false,
          align: "center",
          class: "text-313B41 w-400",
        },
        {
          text: "วันที่เข้ารับการรักษา",
          value: "date_th",
          width: "7%",
          sortable: false,
          align: "center",
          class: "text-313B41 w-400",
        },
        {
          text: "วันที่ขอเอกสาร",
          value: "create_at_th",
          width: "7%",
          sortable: false,
          align: "center",
          class: "text-313B41 w-400",
        },
        {
          text: "ชื่อแพทย์/เลขที่ใบอนุญาต",
          value: "doctor_name",
          width: "17%",
          sortable: false,
          align: "center",
          class: "text-313B41 w-400",
        },
        // {
        //   text: 'Update',
        //   value: 'update_at_th',
        //   width: '10%',
        //   sortable: false,
        //   align: 'center',
        //   class: 'text-313B41 w-400'
        // },
        {
          text: "สถานะ",
          value: "status_th",
          width: "12%",
          sortable: false,
          align: "center",
          class: "text-313B41 w-400",
        },
        {
          text: "Action",
          value: "action",
          width: "15%",
          sortable: false,
          align: "center",
          class: "text-313B41 w-400",
        },
      ],
      dataList: [],
      lockaprove: false,
      total: 0,
      page: 1,
      date_format: "วัน/เดือน/ปี",

      loading: true,

      loading_download: false,
      role_name: sessionStorage.role_name,
      loadingTable: false,
    };
  },
  async created() {
    await this.getDocType();
  },
  async mounted() {
    EventBus.$on("searchNotification", () => {
      this.getStaff();
      this.getData();
    });
    EventBus.$on("getData", this.getData);
    if (sessionStorage.role_name != "แพทย์") {
      this.lockaprove = true;
    }
    await this.getStaff();
    await this.getData();
    this.loading = false;
  },
  beforeDestroy() {
    EventBus.$off("getData");
    EventBus.$off("searchNotification");
  },
  watch: {
    async loading(val) {
      if (val) {
        await this.getData();
        this.loading = false;
      }
    },
    async page() {
      this.loading = true;
    },
    // async filter_doctor () {
    //   this.page = 1
    //   this.loading = true
    // },
    async date_format() {
      this.loading = true;
    },
    async filter_name(val) {
      if (val) {
        this.page = 1;
        this.getData();
      } else {
        this.page = 1;
        this.loading = true;
      }
    },
  },
  computed: {
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    filterStatus(index) {
      this.filter_status = index;
      if (this.page == 1) {
        this.getData();
      } else {
        this.page = 1;
      }
    },
    changePage(page) {
      this.page = page;
    },
    async openRequestDialog() {
      // console.log('open')
      this.$refs.requestDocDialog.open();
    },
    approveDialog(input, age) {
      if (input.doc_code === "MEDICAL_CERTIFICATE") {
        this.$refs.medcertDialog.open(input);
      } else if (input.doc_code === "DRIVING_LICENSE") {
        this.$refs.dialog_driving.open(input);
      } else if (input.doc_code === "FORMFOREINGWORKERS") {
        this.$refs.dialog_foreingworkers.open(input);
      } else if (input.doc_code === "CONTROLLED_HERBS") {
        this.$refs.dialog_controlled_herbs.open(input, age);
      } else if (input.doc_code === "PRESCRIPTION_CERT") {
        this.$refs.dialog_prescription_cert.open(input, age);
      } else if (input.doc_code === "COMMENT_CERT") {
        this.$refs.dialog_comment_cert.open(input, age);
      }
    },
    cancleDialog(id) {
      this.$refs.cancelDialog.open(id);
    },
    formatDate(date) {
      return moment(date).add(543, "year").locale("th").format("DD MMMM YYYY");
    },
    dateFormat(date) {
      return moment(date).locale("th").format("DD/MM/YYYY");
    },
    timeFormat(date) {
      return moment(date).locale("th").format("HH:mm น.");
    },
    async dowloadDialog(item) {
      try {
        this.loading_download = true;
        // console.log("item", item)
        let params = new URLSearchParams();
        params.append("id", item._id);
        params.append("doc_code", item.doc_code);
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/sign/downloadpdf?${params}`,
            {
              headers: {
                "Content-Type": "application/json",
                "Content-Disposition": 'attachment; filename="file.pdf"',
              },
              responseType: "blob",
            }
          )
          .then((res) => {
            const blob = new Blob([res.data], { type: "application/pdf" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `${item.doc_name}.pdf`; // ตั้งชื่อไฟล์ที่จะดาวน์โหลด
            link.click();
            this.loading_download = false;
          })
          .catch((error) => {
            console.error(error);
            this.loading_download = false;
            this.$swal.fire("ผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
          });
      } catch (err) {
        this.loading_download = false;
        console.log(err);
      }
    },
    clearFilter() {
      if (this.role_name !== "แพทย์") {
        this.filter_doctor = {
          name_th: "แพทย์ทั้งหมด",
          one_id: "all",
        };
      }
      this.filter_doc_type = {
        doc_name: "ทั้งหมด",
        doc_code: "",
      }
      this.filter_name = "";
      this.filter_date = "";
      this.date_format = "วัน/เดือน/ปี";
      // console.log("doctor", this.filter_doctor)
      if (this.page == 1) {
        this.getData();
      } else {
        this.page = 1;
      }
    },
    saveDate(date) {
      this.date_format = date ? this.formatDate(date) : "วัน/เดือน/ปี";
      return moment(date).locale("th").format("YYYY-MM-DD");
    },
    async getData() {
      this.loadingTable = true
      this.dataList = []

      try {
        let params = new URLSearchParams();
        // params.append("doctor", sessionStorage.oneId)
        params.append("biz_id", sessionStorage.biz_id);
        params.append("page", this.page);

        // if (this.filter_doctor) {
        //   params.append("doctor", this.filter_doctor.one_id)
        // }
        if (this.filter_doctor) {
          if (this.filter_doctor.one_id != "all") {
            params.append("doctor", this.filter_doctor.one_id);
          }
        }

        if (this.filter_name) {
          params.append("name", this.filter_name);
        }

        if (this.filter_date) {
          params.append("start_time", this.filter_date);
        }

        if (this.filter_status == 1) {
          params.append("status", "request");
        } else if (this.filter_status == 2) {
          params.append("status", "success");
        }

        if (
          this.filter_doc_type &&
          this.filter_doc_type.doc_name !== "ทั้งหมด"
        ) {
          params.append("doc_type", this.filter_doc_type.doc_code);
        }

        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/getListTransaction?${params}`
          )
          .then((res) => {
            if (res.data.result == "success") {
              setTimeout(() => {
                // console.log(">>> transactions", res)
                // this.document_list = res.data.data
                let data = res.data.data[0];
                // console.log("total", data)
                this.statusList[0].number =
                  data.total.length > 0 ? data.total[0].count : 0;
                this.statusList[1].number =
                  data.request_status.length > 0 ? data.request_status[0].count : 0;
                this.statusList[2].number =
                  data.success_status.length > 0 ? data.success_status[0].count : 0;
                // this.statusList[3].number = data.cancel_status.length > 0 ? data.cancel_status[0].count : 0

                if (this.filter_status == 0) {
                  this.total = data.total.length > 0 ? data.total[0].count : 0;
                } else if (this.filter_status == 1) {
                  this.total =
                    data.request_status.length > 0
                      ? data.request_status[0].count
                      : 0;
                } else if (this.filter_status == 2) {
                  this.total =
                    data.success_status.length > 0
                      ? data.success_status[0].count
                      : 0;
                }

                this.dataList = data.result.map((item) => {
                  // console.log(">>> item", item)
                  let status_th;

                  if (item.status == "request") {
                    status_th = "เอกสารที่ร้องขอ";
                  } else if (item.status == "success") {
                    status_th = "สำเร็จ";
                  } else if (item.status == "cancel") {
                    status_th = "ยกเลิก";
                  }

                  let sign = true;
                  let doctor_name = ""
                  let doctor_license = ""
                  // console.log(item.payload);
                  if (item.doc_code === "MEDICAL_CERTIFICATE" || item.doc_code === "FORMFOREINGWORKERS" || item.doc_code === "CONTROLLED_HERBS" || item.doc_code === "PRESCRIPTION_CERT" || item.doc_code === "COMMENT_CERT") {
                    if (item.payload.doctor.one_id == sessionStorage.oneId) {
                      sign = false;
                    }
                    doctor_name = item.payload.doctor.doctor_name;
                    doctor_license = item.payload.doctor.doctor_license;
                  } else if (item.doc_code === "DRIVING_LICENSE") {
                    if (item.payload.doctor_one_id == sessionStorage.oneId) {
                      sign = false;
                    }
                    doctor_name = item.payload.name_doctor_th;
                    doctor_license = item.payload.doctor_license;
                  }
                  return {
                    doc_name: item.doc_name,
                    doc_code: item.doc_code,
                    date_th: this.dateFormat(item.health_check_date), //วันที่เข้ารับการรักษา
                    create_at_th: this.dateFormat(item.request_date), //วันที่ขอเอกสาร
                    status: item.status,
                    status_th: status_th,
                    _id: item._id,
                    item: item.payload,
                    doctor_name: doctor_name,
                    doctor_license: doctor_license,
                    approve_sign: sign,
                    mode: "approve",
                  };
                });
                this.loadingTable = false;
              }, 1500);
            }
          });
      } catch (err) {
        this.loadingTable = false;
        console.log(err);
      }
    },
    async getStaff() {
      try {
        let params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("mode", "all-doctor");
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/getStaff?${params}`)
          .then((res) => {
            // console.log(">>> res", res.data.data, " ---------------")
            let data = res.data.data;

            if (!this.lockaprove) {
              for (let i in data) {
                if (data[i].one_id == sessionStorage.oneId) {
                  this.filter_doctor = data[i];
                }
              }
            }

            this.doctorList = data;

            this.doctorList.unshift({
              name_th: "แพทย์ทั้งหมด",
              one_id: "all",
            });
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getDocType() {
      let params = new URLSearchParams();
      params.append("biz_id", sessionStorage.biz_id);
      await this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/getDocType?${params}`)
        .then((res) => {
          // console.log("res", res);
          let data = res.data.data[0];

          if (data.default.length > 0) {
            // this.document_list.push.apply(this.document_list, data.default);
            this.document_list = this.document_list.concat(data.default);
            // for (let item of data.default) {
            //   this.document_list.push(item);
            // }
          }

          if (data.biz.length > 0) {
            // this.document_list.push.apply(this.document_list, data.biz);
            this.document_list = this.document_list.concat(data.biz);
            //   for (let item of data.biz) {
            //   this.document_list.push(item);
            // }
          }
        });
    },
    searchDoctor() {
      this.page = 1;
      this.loading = true;
    },
    select_dcot_type() {
      this.page = 1;
      this.loading = true;
    },
  },
};
</script>

<style scoped>
.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}

.stylecard {
  /* bg */
  position: absolute;
  /* white */
  background: #fbfffe;
  border-radius: 80px 0px 0px 0px;
}

.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}

.theme-back {
  background-color: #00a99d;
  color: #ffffff;
}

.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}

.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.5rem !important;
}

::v-deep .v-select__selections {
  line-height: 25px;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}

::v-deep .v-data-table-header {
  background: #ceefed;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

::v-deep .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}

::v-deep .v-data-table>.v-data-table__wrapper .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table>.v-data-table__wrapper>table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr {
  background: #ebf7f7;
}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
  border-bottom: none;
}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  border-bottom: none;
}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row),
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table>.v-data-table__wrapper .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ceefed !important;
}

::v-deep .v-text-field>.v-input__control>.v-input__slot>.v-text-field__slot>input {
  line-height: 1.7rem;
}

::v-deep .v-text-field>.v-input__control>.v-input__slot>.v-select__slot>input {
  line-height: 1.7rem;
}

.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #ffffff;
  border-radius: 80px 0px 0px 0px;
}
</style>
